/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Role_ModeratorInputs */

const en_role_moderator = /** @type {(inputs: Role_ModeratorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moderator`)
};

const es_role_moderator = /** @type {(inputs: Role_ModeratorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moderador`)
};

const fr_role_moderator = /** @type {(inputs: Role_ModeratorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modérateur`)
};

const de_role_moderator = /** @type {(inputs: Role_ModeratorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moderator`)
};

const id_role_moderator = /** @type {(inputs: Role_ModeratorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moderator`)
};

/** @type {(inputs: Role_ModeratorInputs) => LocalizedString} */
const ja_role_moderator = en_role_moderator;

/** @type {(inputs: Role_ModeratorInputs) => LocalizedString} */
const zh_role_moderator = en_role_moderator;

/** @type {(inputs: Role_ModeratorInputs) => LocalizedString} */
const ar_role_moderator = en_role_moderator;

/** @type {(inputs: Role_ModeratorInputs) => LocalizedString} */
const it_role_moderator = en_role_moderator;

/** @type {(inputs: Role_ModeratorInputs) => LocalizedString} */
const ru_role_moderator = en_role_moderator;

/** @type {(inputs: Role_ModeratorInputs) => LocalizedString} */
const pt_role_moderator = en_role_moderator;

/** @type {(inputs: Role_ModeratorInputs) => LocalizedString} */
const ko_role_moderator = en_role_moderator;

/**
* | output |
* | --- |
* | "Moderator" |
*
* @param {Role_ModeratorInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const role_moderator = /** @type {((inputs?: Role_ModeratorInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Role_ModeratorInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_role_moderator(inputs)
	if (locale === "es") return es_role_moderator(inputs)
	if (locale === "fr") return fr_role_moderator(inputs)
	if (locale === "de") return de_role_moderator(inputs)
	if (locale === "ja") return ja_role_moderator(inputs)
	if (locale === "zh") return zh_role_moderator(inputs)
	if (locale === "ar") return ar_role_moderator(inputs)
	if (locale === "id") return id_role_moderator(inputs)
	if (locale === "it") return it_role_moderator(inputs)
	if (locale === "ru") return ru_role_moderator(inputs)
	if (locale === "pt") return pt_role_moderator(inputs)
	return ko_role_moderator(inputs)
});